package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed class NonceStatusResult {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : NonceStatusResult()

    @Serializable
    @SerialName("device_pending")
    class Pending(
        @SerialName("id") val pin: String,
    ) : NonceStatusResult() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_registered")
    class Registered(
        @SerialName("id") val pin: String,
    ) : NonceStatusResult() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_does_not_exist")
    class NotExist(
        @SerialName("message") val message: String,
    ) : NonceStatusResult() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    class Error(val message: String) : NonceStatusResult()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onPending: (Pending: Pending) -> R,
        onRegistered: (Registered: Registered) -> R,
        onNotExist: (NotExist: NotExist) -> R,
        onError: (Error: Error) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is Pending -> onPending(Pending(this.pin))
            is Registered -> onRegistered(Registered(this.pin))
            is NotExist -> onNotExist(NotExist(this.message))
            is Error -> onError(Error(this.message))
        }
    }
}